import PurchaseManage from './index';

export default {
    path: '/home/purchase',
    component: PurchaseManage
}